import { render } from "./BreadCrumbs.vue?vue&type=template&id=125fdbf0&scoped=true&ts=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=125fdbf0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125fdbf0"]])

export default __exports__